import { createFileRoute } from "@tanstack/react-router";
import { CompletionViewer } from "~/app/(new)/admin/completions/CompletionViewer";

export const Route = createFileRoute("/_authed/admin/completions/")({
  component: AdminCompletionsPage,
});

function AdminCompletionsPage() {
  return (
    <div className="relative h-full w-full">
      <div className="flex flex-col gap-2 p-12">
        <h1 className="text-2xl font-bold">Completions</h1>
        <CompletionViewer />
      </div>
    </div>
  );
}
